import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { closeModal } from 'ducks/ui/actions';
import Layout from './Layout';
import i41 from 'assets/images/i41.svg';

const DEFAULT_ID = 'modal';

const propTypes = {
  closeModal: PropTypes.func.isRequired,
  open: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  small: PropTypes.bool,
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  extra: PropTypes.any,
  children: PropTypes.any
};

const defaultProps = {
  labels: ['zamknij'],
  id: DEFAULT_ID
}

class ReduxModal extends React.PureComponent {
  constructor() {
    super();
    this.node = document.getElementById('modal');
  }

  static propTypes = propTypes;
  static defaultProps = defaultProps;

  renderChildren = () => {
    const { closeModal, extra, children } = this.props;

    if(typeof children === 'function') return children(
      Layout,
      {
        extra,
        close: closeModal
      }
    );
    return children;
  }

  render() {
    const { id, closeModal, open, style } = this.props;

    return createPortal(
      <div>
        {open === id && (
          <div className="body-wrapper-inner" onClick={closeModal}>
            <div className="modal">
              <div className="modal-content-wrapper" onClick={e => e.stopPropagation()} style={style}>
                <button className="delete-btn" onClick={closeModal}><img src={i41} alt="zamknij" /></button>
                {this.renderChildren()}
              </div>
            </div>
          </div>
        )}
      </div>
    , this.node);
  }
}

const mapState = state => ({
  open: state.ui.modal.open,
  extra: state.ui.modal.extra
});

const mapDispatch = {
  closeModal
};

export default connect(mapState, mapDispatch, null, { withRef: true })(ReduxModal);


// WEBPACK FOOTER //
// ./src/components/reduxModal/ReduxModal.jsx